import clsx from 'clsx';
import React, {ReactChild, ReactElement, ReactType} from 'react';
import AlertCircle from 'react-feather/dist/icons/alert-circle';
import defaultTheme from './message.module.pcss';

export type MessageType = 'error' | 'success' | 'info';

type Props = {
  /**
   * Element node
   * @default 'div'
   */
  as?: ReactType;
  type: MessageType;
  Icon?: ReactElement;
  text: string;
  children?: ReactChild;
  className?: string;
  theme?: {
    root?: string;
    icon?: string;
    error?: string;
    success?: string;
    info?: string;
    text?: string;
    limit?: string;
  };
};

export const Message = ({
  as: ComponentProp = 'div',
  type,
  text,
  className,
  children,
  Icon = <AlertCircle />,
  theme = defaultTheme,
  ...rest
}: Props) => (
  <ComponentProp className={clsx(theme.root, className, theme[type])} {...rest}>
    <span className={theme.icon}>{Icon}</span>
    <span className={theme.text}>{text}</span>
    {children}
  </ComponentProp>
);
